import React from 'react';
import { Box, Chip, Typography } from '@mui/material';

interface AdminAssistInvestorResponsesProps {
  responses: string[];
  onSelect: (text: string) => void;
  readOnly?: boolean;
}

export default function AdminAssistInvestorResponses({
  responses,
  onSelect,
  readOnly = false,
}: AdminAssistInvestorResponsesProps) {
  if (!responses.length) return null;

  return (
    <Box sx={{ mt: 1.25 }}>
      <Typography variant="caption" color="text.secondary" fontWeight={600}>
        Suggested replies for investor
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75, mt: 0.75 }}>
        {responses.map((response, index) => (
          <Chip
            key={`${index}-${response.slice(0, 24)}`}
            label={response}
            variant="outlined"
            clickable={!readOnly}
            onClick={
              readOnly
                ? undefined
                : (event) => {
                    event.stopPropagation();
                    onSelect(response);
                  }
            }
            sx={{
              height: 'auto',
              py: 0.75,
              alignItems: 'flex-start',
              '& .MuiChip-label': {
                whiteSpace: 'normal',
                textAlign: 'left',
                lineHeight: 1.45,
              },
            }}
          />
        ))}
      </Box>
      {!readOnly && (
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
          Click to add to reply box — review before sending
        </Typography>
      )}
    </Box>
  );
}
